import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getDashboardSummary} from './getSummary';

export const dashboardSummaryQueryOptions = (period: string) =>
  queryOptions({
    queryKey: keys.dashboard.summary(period),
    queryFn: () => getDashboardSummary(period),
    staleTime: 30_000,
  });
